import { render } from "./TopRowDatesComponent.vue?vue&type=template&id=1ec2bdcc"
import script from "./TopRowDatesComponent.vue?vue&type=script&lang=js"
export * from "./TopRowDatesComponent.vue?vue&type=script&lang=js"

import "./TopRowDatesComponent.vue?vue&type=style&index=0&id=1ec2bdcc&lang=scss"

import exportComponent from "/Users/vincent/Herd/app.prixo.io/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__